
		
				/** @jsx CsApp3.Core.createPureElement */
				/** @jsxFrag CsApp3.Core.createPureFragment */
			
		{
		
			let appNs = CsApp3.get('elinkerApps/DefaultWebTemplate');
			
			
		appNs.component('body_maintenance.Renderer', class extends CsApp3.Core.PureComponent {
		
			constructor(props){
			
				super(props);
				
				this.appFrame = props._cs_config.appFrame;
			
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
				return(
					<>
					<div  {...{'className': 'maintenance-alert-wr'}}  {...{'data-cs-app-ns': 'elinkerApps/DefaultWebTemplate'}} >{"En mantenimiento"}</div>
					</>
				);
			} 
			
		});
		
			
		}